/**
 * icons { muted, low, moderate, max} -> svg icons
 */
const CONTAINER_BREAKPOINT_MAPPING = [
  { extraSmall: 'extraSmallContainer' },
  { small: 'smallContainer' },
  { medium: 'mediumContainer' },
  { extraLarge: 'extraLargeContainer' },
  { extraLarge: 'largeContainer' }
];

export const mapKeyBreakpointToContainer = (styles, mappings = CONTAINER_BREAKPOINT_MAPPING) => mappings.reduce(
  (acc, map) => {
    Object.entries(map).forEach(([key, value]) => {
      acc[value] = styles[key];
    });
    return acc;
  },
  {}
);

export const subtitlePositionAndSize = ({ width, height, alignment, position, fontRatio }, margin) => {
  const TARGET_RATIO = 16 / 9;
  const TRANSLATE_CONVERTER = {
    left: 0,
    start: 0,
    center: -50,
    middle: -50,
    right: -100,
    end: -100
  };

  const targetHeight = (width / height) < TARGET_RATIO
    ? (1 / TARGET_RATIO) * width
    : height;

  const sizeStyle = {
    fontSize: `${Math.floor(targetHeight / 20)}px`,
    lineHeight: `${Math.floor(targetHeight / 17.7) * fontRatio}px`
  };

  const x = TRANSLATE_CONVERTER[alignment?.horizontal ?? 'center'];
  const y = TRANSLATE_CONVERTER[alignment?.vertical ?? 'left'];

  const positionStyle = {
    top: `${Math.min(Math.max(margin, position?.top), 100 - margin)}%`,
    left: `${Math.min(Math.max(margin, position?.left), 100 - margin)}%`,
    transform: `translate(${x}%, ${y}%)`
  };

  return ({
    ...sizeStyle,
    ...positionStyle
  });
};

export function getElementHeightWithMargin(element) {
  if (!element) return 0;

  const rect = element.getBoundingClientRect();
  const style = window.getComputedStyle(element);

  const marginTop = parseFloat(style.marginTop) || 0;
  const marginBottom = parseFloat(style.marginBottom) || 0;

  return rect.height + marginTop + marginBottom;
}
